export enum ColorTheme {
	NoColor = 'noColor',
}
